import {Injectable} from '@angular/core';
import {deserialize, JsonApiParams, JsonApiResponse} from '@tisa-group/cdk';
import {Observable} from 'rxjs';
import {TisaAuthHttpService} from '../tisa-auth-http.service';
import {HttpHeaders} from '@angular/common/http';

@Injectable()
export class SettingsService {
  constructor(readonly http: TisaAuthHttpService) {}

  getExternalApiKeys(
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<Record<string, Record<string, string>>>> {
    const token = localStorage.getItem('TISA_TOKEN') ?? '';

    const headers = new HttpHeaders({
      authorization: token,
    });

    return this.http
      .get('/settings/external_api_keys', {
        headers,
        params,
      })
      .pipe(deserialize());
  }
}
